/* jshint esversion:6 */
import * as _ from 'underscore';

class Utilities {
    static deepClone(object) {
        let clone = _.clone(object);

		for (let key in clone) {
            if (_.isFunction(clone[key])) {
                continue;
            }
			if (_.isObject(clone[key])) {
				clone[key] = Utilities.deepClone(object[key]);
			}
		}

		return clone;
    }

    static dropCookie(domain, key, data) {
        let expiration = new Date(new Date().getTime() + (60 * 60 * 24 * 365 * 1000)).toGMTString();

        window.document.cookie = `${key}=${encodeURIComponent(JSON.stringify(data))}; expires=${expiration}; path=/; domain=${domain};`;
    }

    static getCookie(key) {
        var entries = window.document.cookie.split(";"),
            data = null;

        for (var i = 0; i < entries.length; ++i) {
            if (entries[i].match(key)) {
                var cookieData = entries[i].split("=");
                if (cookieData.length && cookieData[1] !== undefined && cookieData[1] !== null) {
                    data = JSON.parse(decodeURIComponent(cookieData[1]));
                }
                break;
            }
        }

        return data;

    }

    static clearCookie(domain, key) {
        let expiration = new Date(0).toGMTString();

        window.document.cookie = `${key}=''; expires=${expiration}; path=/; domain=${domain};`;
    }

}

export default Utilities;
